import React from 'react';
import { Stack } from '@mui/material';
import { IPlayButtonProps } from './types';
import { PlayIcon } from '../../../../../icons/PlayIcon';
import { PauseIcon } from '../../../../../icons/PauseIcon';
import { theme } from '../../../../common/styles/theme';

export function PlayButton ({
	className,
	isPlay,
	onClick,
}: IPlayButtonProps) {

	const classNameItem = 'play-button';

	return (
		<Stack
			className={`${classNameItem} ${className} ${isPlay ? 'pause' : 'play'}`}
			sx={{
				position: 'relative',
				justifyContent: 'center',
				alignItems: 'center',
				width: theme.spacing(3.5),
				height: theme.spacing(3.5),
				color: theme.palette.common.white,
				background: theme.palette.primary.main,
				borderRadius: '50%',
				cursor: 'pointer',
				transition: 'all .3s ease',

				'svg': {
					width: theme.spacing(1.3),
					height: theme.spacing(1.3),
				},

				'&.play svg': {
					ml: theme.spacing(.25),
				},

				'&:before': {
					content: '""',
					position: 'absolute',
					inset: '-5px',
				},

				'&:hover, &:focus': {
					background: theme.palette.primary[500],
				},
			}}
			onClick={onClick}
		>
			{isPlay
				? <PauseIcon />
				: <PlayIcon />
			}
		</Stack>
	);
};
